import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import SharedResource from "../qlib/SharedResource";
import Chain from "../qlib/Chain";

/**
 * Manages the header's state
 * @export
 * @class HeaderComponent
 * @extends Component
 */
export default class HeaderComponent extends Component
{
    constructor(element)
    {
        super(element);

        // Used to keep track of how many 'show' requests the header has received
        this.ref_count = new SharedResource();

        this.search_input = element.querySelector('.js-search-dropdown-toggle');
        this.search_dropdown = element.querySelector('.js-search-dropdown')

        this.query = ''
        this.timeout_id = undefined
        
        this.search_input.addEventListener('keyup', event => {
            event.preventDefault()

            if (this.timeout_id !== undefined) clearTimeout(this.timeout_id)

            this.timeout_id = setTimeout(() => {
                this.timeout_id = undefined
                this.queryResult(this.search_input.value)
            }, 500)
        })

        this.queryResult(this.search_input.value)
    }

    async queryResult(new_query)
    {
        if (this.query === new_query) return

        let response = await fetch(`/api/search?query=${new_query}`)
        let json = await response.json()

        let html = ''
        json.forEach(pand => {
            const chunks = pand.name.split(',')
            const city = chunks[0]
            let rest = ''

            if (chunks.length > 1)
            {
                rest = `, ${chunks[1]}`
            }

            html += `<a class="dropdown-item" href="${pand.readon}"><b>${city}</b>${rest}</a>`
            /*

          <a class="dropdown-item" href="#"><b>Alkmaar</b>, lorem ipsum dolor ilsit 123</a>
          <!-- <div class="dropdown-divider mx-3"></div> !-->
            */
        })

        this.search_dropdown.innerHTML = html
        html === '' ? this.search_dropdown.classList.add('d-none') : this.search_dropdown.classList.remove('d-none')
    }

    onMessage(type)
    {
        switch(type)
        {
            case "show":
                this.ref_count.increment();

                Chain(this.element.classList).remove("headroom--unpinned").add("headroom--pinned");
                break;
            
            case "hide":
                this.ref_count.decrement();

                // We only want to hide the header if it isn't at the top of the page and if there are no active 'show' requests
                if (! this.ref_count.hasReferences() && ! this.element.classList.contains("headroom--top"))
                {
                    Chain(this.element.classList).remove("headroom--pinned").add("headroom--unpinned");
                }
                break;
        }
    }
}

SimpleComponentRegistery.register("header", HeaderComponent);